export interface NavPage {
  key: string;       // path like '/contacts'
  label: string;     // Hebrew label
  icon?: string;     // emoji
  children?: NavPage[];
}

export const ALL_PAGES: NavPage[] = [
  { key: '/', label: 'דשבורד', icon: '🏠' },
  {
    key: '/contacts', label: 'אנשי קשר ו-CRM', icon: '👥',
    children: [
      { key: '/donations', label: 'תרומות' },
      { key: '/memberships', label: 'חברויות' },
    ]
  },
  { key: '/mailing', label: 'דיוור ומיילים', icon: '📧' },
  {
    key: '/campaigns', label: 'קמפיינים', icon: '❤️',
    children: [
      { key: '/campaigns/:id/dashboard', label: 'דשבורד קמפיין' },
    ]
  },
  { key: '/tools', label: 'דפי נחיתה וטפסים', icon: '📐' },
  { key: '/income', label: 'הכנסות', icon: '📈' },
  { key: '/expenses', label: 'הוצאות', icon: '📉' },
  { key: '/finances', label: 'פיננסים', icon: '💰' },
  {
    key: '/masav', label: 'מס״ב', icon: '🏦',
    children: [
      { key: '/masav/debits', label: 'קבצי חיובים' },
      { key: '/masav/credits', label: 'קבצי זיכויים' },
      { key: '/masav/returns', label: 'החזרות' },
    ]
  },
  { key: '/calendar', label: 'לוח שנה ואירועים', icon: '📅' },
  { key: '/knowledge', label: 'מרכז ידע', icon: '📚' },
  {
    key: '/volunteers', label: 'מתנדבים', icon: '🤝',
    children: [
      { key: '/volunteer-projects', label: 'פרויקטי התנדבות' },
    ]
  },
  { key: '/workplan', label: 'תכנית עבודה', icon: '📋' },
  { key: '/projects', label: 'פרויקטים', icon: '🗂️' },
  { key: '/beneficiaries', label: 'מוטבים', icon: '🫂' },
  { key: '/permissions', label: 'משתמשי מערכת', icon: '🛡️' },
  { key: '/settings', label: 'הגדרות', icon: '⚙️' },
];

/** Flatten all page keys from the tree */
export function getAllPageKeys(pages: NavPage[] = ALL_PAGES): string[] {
  const keys: string[] = [];
  for (const page of pages) {
    keys.push(page.key);
    if (page.children) {
      keys.push(...getAllPageKeys(page.children));
    }
  }
  return keys;
}
